import { render, staticRenderFns } from "./CustomizeMetalZ.vue?vue&type=template&id=568d0125&scoped=true"
import script from "./CustomizeMetalZ.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalZ.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalZ.vue?vue&type=style&index=0&id=568d0125&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568d0125",
  null
  
)

export default component.exports